module.exports = __webpack_public_path__ + "static/media/portfolio.ac4729ab.svg";